var map = {
	"./Bulldozer-green.png": 69601,
	"./Bulldozer-grey.png": 38778,
	"./Bulldozer-red.png": 28907,
	"./Bulldozer-yellow.png": 35071,
	"./Bus-green.png": 16902,
	"./Bus-grey.png": 35831,
	"./Bus-red.png": 5771,
	"./Bus-yellow.png": 24283,
	"./Car-green.png": 5116,
	"./Car-grey.png": 60493,
	"./Car-red.png": 41942,
	"./Car-yellow.png": 80406,
	"./Crane-green.png": 47114,
	"./Crane-grey.png": 35531,
	"./Crane-red.png": 45380,
	"./Crane-yellow.png": 16072,
	"./Loader-green.png": 42265,
	"./Loader-grey.png": 44523,
	"./Loader-red.png": 29946,
	"./Loader-yellow.png": 32623,
	"./Motorcycle-green.png": 18859,
	"./Motorcycle-grey.png": 96396,
	"./Motorcycle-red.png": 42713,
	"./Motorcycle-yellow.png": 41285,
	"./PickUp-green.png": 49536,
	"./PickUp-grey.png": 85554,
	"./PickUp-red.png": 19835,
	"./PickUp-yellow.png": 62664,
	"./Roller-green.png": 30133,
	"./Roller-grey.png": 41777,
	"./Roller-red.png": 96915,
	"./Roller-yellow.png": 92229,
	"./SUV-green.png": 77000,
	"./SUV-grey.png": 95911,
	"./SUV-red.png": 79245,
	"./SUV-yellow.png": 5454,
	"./Sweeper-green.png": 60499,
	"./Sweeper-grey.png": 95028,
	"./Sweeper-red.png": 88077,
	"./Sweeper-yellow.png": 43356,
	"./Tanker-green.png": 28549,
	"./Tanker-grey.png": 51379,
	"./Tanker-red.png": 13360,
	"./Tanker-yellow.png": 74525,
	"./Truck-gray.png": 49749,
	"./Truck-green.png": 66272,
	"./Truck-red.png": 95932,
	"./Truck-yellow.png": 8011,
	"./Van-green.png": 8461,
	"./Van-grey.png": 1269,
	"./Van-red.png": 39425,
	"./Van-yellow.png": 28788,
	"./Yatch-green.png": 48638,
	"./Yatch-grey.png": 27843,
	"./Yatch-red.png": 5545,
	"./Yatch-yellow.png": 64858,
	"./dumper-green.png": 44732,
	"./dumper-grey.png": 45324,
	"./dumper-red.png": 96657,
	"./dumper-yellow.png": 88776,
	"./forklift-green.png": 7224,
	"./forklift-grey.png": 78776,
	"./forklift-red.png": 28320,
	"./forklift-yellow.png": 91338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8786;